import styled from 'styled-components'
import { Dayjs } from 'dayjs'
import React, { useCallback, useRef } from 'react'
import { TailSpin } from 'react-loader-spinner'
import Popup from 'reactjs-popup'
import 'emoji-picker-element'
import { PopupActions } from 'reactjs-popup/dist/types'
import { useDomainUtmSource } from '../utils'

export const Empty = styled.div.attrs(props => ({
  children: <TailSpin color={props.theme.themeColor}/>
}))`
  flex: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ChatWindowContainer = styled.div`
  flex: none;
  display: flex;
  min-height: 1px;
  height: 100vh;
  width: 100vw;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  background-color: #FFFFFF;
`
export const Head = styled.div`
  flex: none;
  height: 60px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  color: #fff;
  background-color: ${({ theme }) => theme.themeColor};
  background-image: ${({ theme }) => theme.backgroundImage};
`
export const HeadIcon = styled.img.attrs(({ theme }) => ({
  src: theme.logo
}))`
  flex: none;
  width: 40px;
  height: 40px;
`
export const NameAndSlogan = styled.div`
  flex: auto;
  min-width: 1px;

  .name {
    font-size: 15px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .slogan {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
export const CloseButton = styled.div.attrs({
  children: (
    <svg className="icon">
      <use xlinkHref="#icon-guanbi"/>
    </svg>
  )
})`
  cursor: pointer;

  .icon {
    font-size: 20px;
    cursor: pointer
  }

  .text {
    color: #FFFFFF;
    font-size: 14px;
  }
`
export const MessagesContainer = styled.div`
  flex: auto;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
`
export const Date = styled.div.attrs<{ date: Dayjs }>(({ date }) => ({
  children: date.format('YYYY-MM-DD')
}))<{ date: Dayjs }>`
  && {
    height: 28px;
    padding: 0 16px;
    border-radius: 14px;
    margin: 20px auto;
    background-color: #ECEDF4;
    color: #8D8D8D;
    font-size: 12px;
    font-weight: bold;
    line-height: 28px;
  }
`
export const FileContainer = styled.div<{ visible: boolean }>`
  && {
    display: ${({ visible }) => visible ? 'block' : 'none'};
  }
`
export const InputContainer = styled.div`
  flex: none;
  height: 50px;
  width: 100%;
  padding: 0 12px;
  border-top: 1px solid rgba(0, 0, 0, .12);
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 4px;
`
export const Input = styled.input.attrs({
  type: 'textarea',
  placeholder: '点击输入或者直接粘贴图片，按“Enter”键发送',
})`
  flex: auto;
  height: 100%;
  border: none;
  padding: 17px 4px;

  &:focus {
    outline: none;
  }
  &::placeholder {
    font-size: 0.75rem;
  }
`
export const SendButton = styled.div.attrs({
  children: <img src="https://img.bagevent.com/resource/20200628/1618387591234038.png" alt="发送"/>
})`
  && {
    cursor: pointer;

    img {
      width: 16px;
      height: 16px;
    }
  }
`
const CompanyContainer = styled.div`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #8D8D8D;
  font-size: 10px;
  background: #F6F8FA;
`
const CompanyLogo = styled.img.attrs({
  src: 'https://static.marketup.cn/marketup/resources/img/logo_black.png',
  alt: 'MarketUP'
})`
  height: 14px;
  width: auto;
  margin: 0 2px;
  display: inline-block;
  cursor: pointer;
`

interface CompanyProps {

}

export const Company: React.VFC<CompanyProps> = ({  }) => {
  const domain = useDomainUtmSource('https://www.marketup.cn/')
  return (
    <CompanyContainer>
      本页面由
      <CompanyLogo onClick={() => window.open(domain, '_blank')}/>
      提供技术支持
    </CompanyContainer>
  )
}

const EmojiButton = styled.div.attrs({
  children: '\u{1F600}'
})`
  cursor: pointer;
`

export interface Emoji {
  emoji: {
    group: number
    order: number
    tags: string[]
    annotation: string
    unicode: string
    version: number
  }
  skinTone: number
  unicode: string
}

export interface EmojiPickerProps {
  onClick?: (emoji: Emoji) => void
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({ onClick }) => {
  const popupRef = useRef<PopupActions>(null)
  const onClickRef = useRef(onClick)
  onClickRef.current = onClick
  const listener = useCallback((e: any) => {
    onClickRef.current?.(e.detail)
  }, [])
  return (
    <Popup
      ref={popupRef}
      trigger={<EmojiButton/>}
      onOpen={() => {
        const picker = document.querySelector('emoji-picker')
        if (picker) {
          picker.removeEventListener('emoji-click', listener)
          picker.addEventListener('emoji-click', listener)
        } else {
          console.warn('picker not found')
        }
      }}
      position="top right"
      closeOnDocumentClick={true}
    >
      <emoji-picker class="light" locale="zh"/>
    </Popup>
  )
}
